import { Component, OnInit } from '@angular/core';
import { AnalitycsService } from './core/services/analitycs.service';
import { filter, lastValueFrom } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SeoService } from './core/services/seo.service';
import { Constants } from './core/utils/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(
    private analyticsService: AnalitycsService,
    private router: Router,
    private route: ActivatedRoute,
    private seoService: SeoService
  ) {}

  ngOnInit() {
    // Inicializar los metadatos predeterminados al cargar la aplicación
    this.seoService.setDefaultMetaTags();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const path: string = event.urlAfterRedirects;

        if (!path) return;

        const hasPixel = path.includes('pixelId');
        const hasGtm = path.includes('gtmId');
        if (!hasPixel && !hasGtm) return;

        const isConfirmationPage = /^\/order\/.+\/confirmation/.test(path);

        let order = localStorage.getItem(Constants.Keys.OrderConfirmation);
        if (!isConfirmationPage || !order) return;

        const pixelId = this.route.snapshot.queryParams['pixelId'];
        const gtmId = this.route.snapshot.queryParams['gtmId'];
        const { totalToPay } = JSON.parse(order);

        const isPixelAdded = !!document.getElementById('meta-pixel');
        if (pixelId && !isPixelAdded) {
          const script = document.createElement('script');
          script.id = 'meta-pixel';
          script.innerHTML = `
            !function(f, b, e, v, n, t, s) {
              if (f.fbq) return;
              n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
              };
              if (!f._fbq) f._fbq = n;
              n.push = n;
              n.loaded = true;
              n.version = '2.0';
              n.queue = [];
              t = b.createElement(e);
              t.async = true;
              t.src = v;
              s = b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t, s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

            fbq('init', '${pixelId}');
            fbq('track', 'Purchase', {
              value: ${totalToPay},
              currency: 'DOP'
            });
          `;
          document.head.appendChild(script);
        }

        const isGtmAdded = !!document.getElementById('gtm-script');
        if (gtmId && !isGtmAdded) {
          (window as any).dataLayer = (window as any).dataLayer || [];
          const gtmScript = document.createElement('script');
          gtmScript.id = 'gtm-script';
          gtmScript.innerHTML = `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
          `;
          document.head.appendChild(gtmScript);
          (window as any).dataLayer.push({
            event: 'purchase',
            value: totalToPay,
            currency: 'DOP',
          });
        }

        this.router.navigate([], {
          queryParams: { pixelId: null, gtmId: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      });

    lastValueFrom(
      this.analyticsService.logEventVisit({
        data: {
          type: 'clients',
        },
      })
    );
  }
}
